module.exports = __webpack_public_path__ + "static/media/43-1.1f690884.mp3";